<template>
  <div class="contact full">
    <div class="contactcontent">
      <div style="display: flex;flex-flow: column;align-items: center;width: 20%;">
          <p style="font-size: 3vw;margin:0;letter-spacing: 20px;">ENQUIRY</p>
          <!-- <img style="width: 40%;margin: .5rem;"  :src="GLOBAL.imgserve+'/contact/title.png'" alt="" /> -->
          <img style="width: 50%;margin: .5rem;"  :src="GLOBAL.imgserve+'/contact/ABN.png'" alt="" />
          <img style="width: 40%;margin: .5rem;"  :src="GLOBAL.imgserve+'/contact/contactus.png'" alt="" />

      </div>
      <div style="text-align: start;width: 30%;">
        <p style="text-align: center;">If you are keen to purchase a home that befits your lifestyle, don’t hestitate to get in touch with us!</p>
        <p>
          Email: <span style="color:#347589;">inquiries@abnholding.com</span>
          <br>
          Tel: <a href="Tel:+65 87523168"  style="color:#347589;"><span> +65 87523168</span></a>
        </p>
        <p>Submit An Enquiry</p>
      </div>
      <div style="display: flex;flex-flow: column;align-items: center;width: 30%;">
          <input class="contactinput" type="text" name="Name" placeholder="Name" v-model="Name" required="required">
          <input class="contactinput" type="text" placeholder="Phone" v-model="Phone">
          <input class="contactinput" type="text" placeholder="Email" v-model="Email" required="required">
          <div style="width:100%;text-align: start;">
            <p style="    margin-block-start: 0;
    margin-block-end: 0;
    margin-top: 10px;">Choose You Home</p>
            <div style="width:100%;display: flex;justify-content: space-around;">
              <div>
             <input type="radio" placeholder="Email" name="Choose" value="Plot 1" v-model="Choose"  id="Plot1"><label for="Plot1">Plot 1</label>
              </div>
              <div>
             <input type="radio" placeholder="Email" name="Choose" value="Plot 3" v-model="Choose" id="Plot3"><label for="Plot3">Plot 3</label>
              </div>
              <div>
             <input type="radio" placeholder="Email" name="Choose" value="Plot 4" v-model="Choose"  id="Plot4"><label for="Plot4">Plot 4</label>
              </div>
              <div>
             <input type="radio" placeholder="Email" name="Choose" value="Plot 5" v-model="Choose" id="Plot5"><label for="Plot5">Plot 5</label>
              </div>
            </div>
          </div>
          <div style="width:100%;text-align: start;">
            <p style="    margin-block-start: 0;
    margin-block-end: 0;
    margin-top: 10px;">Message</p>
          <textarea rows="3" style="width:100%" type="text"  v-model="Message"> </textarea>
          </div>
          <div style="display: flex;align-items: center;">
            <input type="checkbox" name="clickbtn" id="clickbtn" v-model="clickbtn"  value='1'>
            <label for="clickbtn">
            <p style="font-size:12px">
              <span >By submitting this online registration enquiry, you agree that your personal data may be collected, used and disclosed 
by ABN Holdings Pte. Ltd. and its affiliates, service providers and agents to provide and improve customer service relat-ed to Pasir Panjang Hills or as required by law</span>
            </p>
            </label>
            
          </div>
          <div class="btn" style="margin-bottom: 20px;margin-top: 20px;width: 85%;color: rgb(201, 161, 57);background: rgb(111,148,166);font-size: 1.2rem;font-weight: 600;" @click="updeta()">
            SUBMIT
          </div>
      </div>
      <div style="width: 37%;font-size:12px;padding-bottom: 50px;text-align: start;">
        <p>
        Reasonable care has been taken in the preparation of the visualization but the developer or its agents do not warrant the accuracy. To the extent permissible by law, the perspectives and animation are a visual representation and may not be relied on as statements or representations of the fact and details of the building design are subject to the final design of the developers, architect and approval from the relevant authorities. 
        </p>
        <p>
        Copyright@2021 (8 Dragons) By ABN Pte Ltd. All Rights Reserved.
        </p>
      </div>
      <!-- <div style="width: 45%;font-size:12px;padding-bottom: 50px;">
      </div> -->
      <!-- <div></div> -->
    </div>




  </div>
</template>


<script>
import md5 from 'js-md5';
export default {
  data() {
    return {
      Name:'',
      Phone:'',
      Email:'',
      Choose:"",
      Message:'',
      clickbtn:'',

          }
  },
  methods:{
      objKeySort(obj) {
      //排序的函数
      //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
      let newkey = Object.keys(obj).sort()
      let newObj = {} //创建一个新的对象，用于存放排好序的键值对
      for (let i = 0; i < newkey.length; i++) {
        //遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]] //向新创建的对象中按照排好的顺序依次增加键值对
      }
      return newObj //返回排好序的新对象
    },
    updeta(){
      // 邮件发送
    if(!this.Name && !this.Email){
      alert('Did not fill in Email Or Name !')
    }else if(this.clickbtn){
      let data  = {
          name:this.Name,
          phone:this.Phone,
          email:this.Email,
          address:this.Choose,
          msg:this.Message
      }
      var str = ''
      for (const key in this.objKeySort(data)) {
        if (
          this.objKeySort(data)[key] !== null &&
          typeof this.objKeySort(data)[key] !== 'undefined'
        ) {
          str += this.objKeySort(data)[key]
        }
      }
      let signature = md5(str + 'c1d65f3667324592a071ebec5038f38c') //请求签名
      // console.log(this.Choose+this.Email+this.Message+this.Name+this.Phone+'c1d65f3667324592a071ebec5038f38c')
      // console.log(md5(this.Choose+this.Email+this.Message+this.Name+this.Phone+'c1d65f3667324592a071ebec5038f38c'))
      // 邮件发送 
      this.$http.get('https://api.singmap.com/broke-manager-service/other/sendMailByCc',{
            params:{
              name:this.Name,
              email:this.Email,
              phone:this.Phone,
              address:this.Choose,
              msg:this.Message,
              signature:signature
            }
          }).then(response=>{
            if(response.data.status == 200){
              // 发送成功清除输入内容！
            alert('Email sent successfully!')
            this.Name=""
            this.Choose=""
            this.Email=""
            this.Message=""
            this.Phone=""
            }else{
              alert('Email sending exception!')
            }

            console.log(response)
          })
      }else{
        alert('Please agree and check the content！')
      }
    },




    
  }
}
</script>

<style >
.contact{
   overflow: auto;

}





.contactcontent{
  margin-top: 10%;
width: 100%;
height: 100%;
    display: flex;
    flex-flow: column;
    align-items: center;
}

.contactinput{
    background: transparent;
    border-width: 0px;
    border-bottom: 3px solid rgb(201,161,57);
    font-weight: 600;
    /* font-size: x-large; */
    margin-top: 10px;
    margin-bottom: 10px;
    color: white;
    width: 100%;
}
.contactinput::-webkit-input-placeholder { color:white; }

</style>

